import { render, staticRenderFns } from "./ProjectGroupNew.vue?vue&type=template&id=49a6575d"
import script from "./ProjectGroupNew.vue?vue&type=script&lang=js"
export * from "./ProjectGroupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports